import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HTTPMethods } from '@core/enums';
import { createPaths, findPath } from '@core/helpers/paths';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, forkJoin, map, Observable, of, throwError } from 'rxjs';
import { CallArguments } from '@core/interfaces/call-arguments';
import { ObjectDict } from '@core/interfaces/object-dict';
import { paramsToBody } from '@core/helpers';
import { APIOptions } from '@core/classes/api-options';
import { PROJECTS } from '@core/constants';

@Injectable({
  providedIn: 'root',
})
export class APIService {
  private _http: HttpClient = inject(HttpClient);
  protected _paths: string[] = [];

  protected readonly _api =
    // environment.project === PROJECTS.BENEFICIARIES ? {
    //
    //   // bemeficiaries
    //   token: {
    //     methods: [HTTPMethods.GET]
    //   },
    //   'get-demographics': {
    //     methods: [HTTPMethods.POST]
    //   },
    //   'latested-version': {
    //       methods: [HTTPMethods.GET]
    //   }
    // } :
    {
      token: {
        methods: [HTTPMethods.GET],
      },

      'get-all-unknown-values': {
        methods: [HTTPMethods.POST],
      },

      // user-ctr
      profile: {
        methods: [HTTPMethods.GET],
      },

      // email-ctr
      email: {
        send: {
          methods: [HTTPMethods.POST],
        },
      },

      // current-illness-ctr
      'get-current-illness': {
        methods: [HTTPMethods.POST],
      },

      // codings-ctr
      'get-icd10': {
        methods: [HTTPMethods.POST],
      },
      'get-codings_filter': {
        methods: [HTTPMethods.POST],
      },
      'get-codings_abreviations': {
        methods: [HTTPMethods.POST],
      },
      'get-codings': {
        methods: [HTTPMethods.POST],
      },
      'get-atc_code': {
        methods: [HTTPMethods.POST],
      },
      'get-atc': {
        methods: [HTTPMethods.POST],
      },
      'get-all_codings_not': {
        methods: [HTTPMethods.POST],
      },
      'get-all_codings_no_limit': {
        methods: [HTTPMethods.POST],
      },
      'get-all_codings': {
        methods: [HTTPMethods.POST],
      },
      'get-all_atc': {
        methods: [HTTPMethods.POST],
      },
      'get-quantity-unit-descriptions': {
        methods: [HTTPMethods.GET],
      },

      // phs-ctr
      'get-products_substance': {
        methods: [HTTPMethods.POST],
      },
      'get-products_atc': {
        methods: [HTTPMethods.POST],
      },
      'get-product_unit_codings': {
        methods: [HTTPMethods.POST],
      },
      'get-product_strength': {
        methods: [HTTPMethods.POST],
      },
      'get-product_route': {
        methods: [HTTPMethods.POST],
      },
      'get-product_pack_unit': {
        methods: [HTTPMethods.POST],
      },
      'get-product_pack_desc': {
        methods: [HTTPMethods.POST],
      },
      'get-product_form': {
        methods: [HTTPMethods.POST],
      },
      'get-product_duration_unit': {
        methods: [HTTPMethods.POST],
      },
      'get-product_atc': {
        methods: [HTTPMethods.POST],
      },
      'get-product_active_substance': {
        methods: [HTTPMethods.POST],
      },
      'get-product': {
        methods: [HTTPMethods.POST],
      },
      'get-product_for_atc': {
        methods: [HTTPMethods.POST],
      },

      // print-client
      'get-ps_pdf': {
        methods: [HTTPMethods.POST],
      },
      'get-ep_pdf': {
        methods: [HTTPMethods.POST],
      },
      'get-cda': {
        methods: [HTTPMethods.POST],
      },

      // access-patient-data-ctr
      patient: {
        'set-OTP': {
          methods: [HTTPMethods.POST],
        },
        get: {
          methods: [HTTPMethods.POST],
        },
        demographics: {
          methods: [HTTPMethods.POST],
        },
        reset: {
          methods: [HTTPMethods.PATCH],
        },
      },

      // patient-summary-ctr
      'unknown-values': {
        methods: [HTTPMethods.POST],
      },
      'save-psversion': {
        methods: [HTTPMethods.POST],
      },
      'insert-newversion': {
        methods: [HTTPMethods.POST],
      },
      'get-unknown-values': {
        methods: [HTTPMethods.POST],
      },
      'get-ps-entries': {
        methods: [HTTPMethods.POST],
      },
      'get-all-unkown-values': {
        methods: [HTTPMethods.POST],
      },
      'discard-psversion': {
        methods: [HTTPMethods.POST],
      },
      'unsaved-version': {
        methods: [HTTPMethods.GET],
      },
      'number-of-unsaved-version': {
        methods: [HTTPMethods.GET],
      },
      'latested-version': {
        methods: [HTTPMethods.GET],
      },
      'get-ps-versioning': {
        methods: [HTTPMethods.GET],
      },
      'get-old-unsaved-version': {
        methods: [HTTPMethods.GET],
      },
      'current-version': {
        methods: [HTTPMethods.GET],
      },

      // allergies-ctr
      'delete-allergies': {
        methods: [HTTPMethods.PUT],
      },
      allergies: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'get-allergies': {
        methods: [HTTPMethods.POST],
      },

      // autonomy-invalidity-ctr
      'delete-autonomy-invalidity': {
        methods: [HTTPMethods.PUT],
      },
      'autonomy-invalidity': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'get-autonomy-invalidity': {
        methods: [HTTPMethods.POST],
      },

      // contact-persons-ctr
      'delete-cp': {
        methods: [HTTPMethods.PUT],
      },
      cp: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'get-cp': {
        methods: [HTTPMethods.POST],
      },

      // documents-ctr
      'delete-document': {
        methods: [HTTPMethods.PUT],
      },
      'get-documents-list': {
        methods: [HTTPMethods.POST],
      },
      document: {
        methods: [HTTPMethods.POST],
      },
      'get-orcd-document': {
        methods: [HTTPMethods.POST],
      },
      'orcd-document-status': {
        methods: [HTTPMethods.PUT],
      },

    // demographic-ctr
    demographics: {
      methods: [HTTPMethods.PUT],
    },
    'get-demographics': {
      methods: [HTTPMethods.POST],
    },
    'request-update-contact-details': {
      methods: [HTTPMethods.POST],
    },
    'request-update-address': {
      methods: [HTTPMethods.POST],
    },
    'confirm-update-contact-details': {
      methods: [HTTPMethods.POST],
    },
    'get-contact-details': {
      methods: [HTTPMethods.GET],
    },

      // diagnostics-test-ctr
      'diagnostic-test': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-diagnostic-test': {
        methods: [HTTPMethods.PUT],
      },
      'get-diagnostic-test': {
        methods: [HTTPMethods.POST],
      },

      // illness-ctr
      illness: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-illness': {
        methods: [HTTPMethods.PUT],
      },
      'get-illness': {
        methods: [HTTPMethods.POST],
      },

      // insurance-ctr
      insurance: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-insurance': {
        methods: [HTTPMethods.PUT],
      },
      'get-insurance': {
        methods: [HTTPMethods.POST],
      },

      // medical-devices-ctr
      'medical-devices': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-medical-devices': {
        methods: [HTTPMethods.PUT],
      },
      'get-medical-devices': {
        methods: [HTTPMethods.POST],
      },

      // medication-ctr
      medication: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-medication': {
        methods: [HTTPMethods.PUT],
      },
      'get-medication': {
        methods: [HTTPMethods.POST],
      },

      // pregnancy-ctr
      pregnancy: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-pregnancy': {
        methods: [HTTPMethods.PUT],
      },
      'get-pregnancy': {
        methods: [HTTPMethods.POST],
      },

      // prescriptions-ctr
      prescription: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-prescription': {
        methods: [HTTPMethods.PUT],
      },
      'get-prescription': {
        methods: [HTTPMethods.POST],
      },

      // social-history-ctr
      'social-history': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-social-history': {
        methods: [HTTPMethods.PUT],
      },
      'get-social-history': {
        methods: [HTTPMethods.POST],
      },

      // surgical-procedures-ctr
      'surgical-procedures': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-surgical-procedures': {
        methods: [HTTPMethods.PUT],
      },
      'get-surgical-procedures': {
        methods: [HTTPMethods.POST],
      },

      // treatment-recommendations-ctr
      'treatment-recommendations': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-treatment-recommendations': {
        methods: [HTTPMethods.PUT],
      },
      'get-treatment-recommendations': {
        methods: [HTTPMethods.POST],
      },

      // vaccinations-ctr
      vaccinations: {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'delete-vaccinations': {
        methods: [HTTPMethods.PUT],
      },
      'get-vaccines_by_description': {
        methods: [HTTPMethods.POST],
      },
      'get-vaccines_by_brand_name': {
        methods: [HTTPMethods.POST],
      },
      'get-vaccinations': {
        methods: [HTTPMethods.POST],
      },
      'get-vaccination_brands': {
        methods: [HTTPMethods.POST],
      },

      // vaccinations-euvac-ctr
      'get-vaccinations-euvac': {
        methods: [HTTPMethods.POST],
      },
      'vaccinations-euvac': {
        methods: [HTTPMethods.POST],
      },
      'vaccinations-euvac/status': {
        methods: [HTTPMethods.PUT],
      },

      // vital-signs-ctr
      'vital-sign': {
        methods: [HTTPMethods.PUT, HTTPMethods.POST],
      },
      'vital-signs': {
        methods: [HTTPMethods.POST],
      },
      'delete-vital-sign': {
        methods: [HTTPMethods.PUT],
      },
      'get-vital-sign': {
        methods: [HTTPMethods.POST],
      },
      'get-blood-presure': {
        methods: [HTTPMethods.POST],
      },
    };

  init() {
    createPaths(this._paths, this._api, '');
  }

  call<T>(args: APIOptions<T>) {
    if (this._paths.includes(args.path!)) {
      let apiCall = findPath(this._api, args.path!);
      if (apiCall && apiCall.methods && apiCall.methods.length > 0) {
        if (!args.type && apiCall.methods.length === 1) {
          args.type = apiCall.methods[0];
        } else if (!args.type && apiCall.methods.length > 1) {
          args.type = (apiCall.methods as Array<HTTPMethods>).some(
            (value) => value === HTTPMethods.GET
          )
            ? HTTPMethods.GET
            : apiCall.methods[0];
        }
        if (
          apiCall.replace &&
          apiCall.replace.length > 0 &&
          args.params &&
          args.params.keys().length > 0
        ) {
          let valid = true;
          apiCall.replace.forEach((key: string) => {
            valid =
              valid &&
              (args.params?.keys().some((aKey) => {
                return key === aKey;
              }) ||
                false);
          });
          if (valid) {
            args.params.keys().forEach((key) => {
              args.path = args.path!.replace(key, args?.params?.get(key) || '');
            });
            apiCall.replace.forEach((key: string) => {
              args.params = args.params?.delete(key);
            });
          } else {
            //throwError(() => new Error('Is not actually the same'));
            return of(null);
          }
        }

        switch (args.type) {
          case HTTPMethods.GET: {
            return this.get<T | any>(args.path!, args.headers, args.params);
          }
          case HTTPMethods.PATCH: {
            return this.patch<T | any>(args.path!, args.headers, args.params);
          }
          case HTTPMethods.POST: {
            return this.post<T | any>(args.path!, args.headers, args.params, args.body);
          }
          case HTTPMethods.PUT: {
            return this.put<T | any>(args.path!, args.headers, args.params, args.body);
          }
          case HTTPMethods.DELETE: {
            return this.delete<T | any>(args.path!, args.headers, args.params);
          }
          default: {
            return null;
          }
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  callMany(calls: CallArguments<any>[], externalCalls?: CallArguments<any>[]) {
    if (calls.length > 0) {
      let newCalls: ObjectDict = {};
      calls.forEach((call: CallArguments<any>, index) => {
        newCalls[call.name || 'data' + index] = this.call({
          path: call.path,
          type: call.type,
          headers: call.headers,
          params: call.params,
          body: call.body,
          responseType: call.responseType,
        });
      });
      if (externalCalls && externalCalls.length > 0) {
        externalCalls.forEach((call: CallArguments<any>, index) => {
          newCalls[call.path || 'other' + index] = call.observable;
        });
      }
      return forkJoin(newCalls);
    }
    return null;
  }

  get<T>(path: string, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    headers =
      headers ||
      new HttpHeaders({
        'Content-Type': 'application/json',
      });
    return this._http
      .get<T>(`${environment.app_url}${environment.paths.api}${path}`, {
        headers: headers,
        params: params,
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => new Error('Error fetching data'));
        })
      );
  }

  patch<T>(path: string, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    headers =
      headers ||
      new HttpHeaders({
        'Content-Type': 'application/json',
      });
    return this._http
      .patch<T>(
        `${environment.app_url}${environment.paths.api}${path}`,
        {
          headers: headers,
        },
        {
          params: params,
        }
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => new Error('Error fetching data'));
        })
      );
  }

  post<T>(
    path: string,
    headers?: HttpHeaders,
    params?: HttpParams,
    body?: object | HttpParams
  ): Observable<T> {
    headers =
      headers ||
      new HttpHeaders({
        'Content-Type': 'application/json',
      });
    return this._http
      .post<T>(
        `${environment.app_url}${environment.paths.api}${path}`,
        body instanceof HttpParams ? paramsToBody(body || new HttpParams()) : body,
        {
          headers: headers,
        }
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => new Error('Error fetching data'));
        })
      );
  }

  put<T>(
    path: string,
    headers?: HttpHeaders,
    params?: HttpParams,
    body?: object | HttpParams
  ): Observable<T> {
    headers =
      headers ||
      new HttpHeaders({
        'Content-Type': 'application/json',
      });
    return this._http
      .put<T>(
        `${environment.app_url}${environment.paths.api}${path}`,
        body instanceof HttpParams ? paramsToBody(body || new HttpParams()) : body,
        {
          headers: headers,
        }
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => new Error('Error fetching data'));
        })
      );
  }

  delete<T>(path: string, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    headers =
      headers ||
      new HttpHeaders({
        'Content-Type': 'application/json',
      });
    return this._http
      .delete<T>(`${environment.app_url}${environment.paths.api}${path}`, {
        headers: headers,
        params: params,
      })
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          return throwError(() => new Error('Error fetching data'));
        })
      );
  }

  getEdDocument(payload: {
    user_id: string;
    pharmacy_id: string;
    eD_document_id: string;
  }): Observable<any> {
    return this._http.post<any>(`/ncpb_geteD`, payload);
  }
}
